export const PRISM_BUSINESS_TIME_ZONE = 'America/Chicago';

const formatters = new Map<string, Intl.DateTimeFormat>();

function calendarDateValue(value: Date, timeZone: string): number {
    let formatter = formatters.get(timeZone);
    if (!formatter) {
        formatter = new Intl.DateTimeFormat('en-US', {
            timeZone,
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
        });
        formatters.set(timeZone, formatter);
    }
    const parts = new Map(formatter.formatToParts(value).map(part => [part.type, Number(part.value)]));
    return Date.UTC(parts.get('year')!, parts.get('month')! - 1, parts.get('day')!);
}

/**
 * Whole business-calendar days between two dates. Time-of-day is deliberately ignored so a due
 * date does not become overdue halfway through a workday, and the explicit time zone keeps browser
 * and server results identical.
 */
export function calendarDaysBetween(
    from: Date | string,
    to: Date | string,
    timeZone = PRISM_BUSINESS_TIME_ZONE,
): number | null {
    const fromDate = from instanceof Date ? from : new Date(from);
    const toDate = to instanceof Date ? to : new Date(to);
    if (Number.isNaN(fromDate.getTime()) || Number.isNaN(toDate.getTime())) return null;
    return Math.round((calendarDateValue(toDate, timeZone) - calendarDateValue(fromDate, timeZone)) / 86_400_000);
}
